import React, { useEffect, useState } from "react";
import { Activity } from "lucide-react";
import api from "../../api/axios";
import Swal from "sweetalert2";

const LiveLogs = () => {
  const [logs, setLogs] = useState([]);

  const [search, setSearch] = useState("");
  const [date, setDate] = useState(() => {
    return new Date().toISOString().split("T")[0];
  });

  const [loading, setLoading] = useState(true);

  const fetchLogs = async () => {
    try {
      const res = await api.get("/hrms/devices/alllogs", {
        params: { date },
      });

      let payload = res.data;

      if (payload && Array.isArray(payload.data)) {
        payload = payload.data;
      } else if (!Array.isArray(payload)) {
        console.warn("Unexpected logs format:", payload);
        payload = [];
      }

      setLogs(payload);
    } catch (err) {
      Swal.fire("Error", "Failed to fetch logs", "error");
    }
  };

  useEffect(() => {
    setLoading(true);
    fetchLogs().finally(() => setLoading(false));
  }, [date]);

  const formatTime = (ts) => {
    if (!ts) return "-";
    const timePart = ts.slice(11, 16);
    const [h, m] = timePart.split(":");
    const hour = parseInt(h);
    const ampm = hour >= 12 ? "PM" : "AM";
    const hour12 = hour % 12 || 12;
    return `${hour12}:${m} ${ampm}`;
  };

  const formatDate = (ts) => {
    if (!ts) return "-";
    const [y, m, d] = ts.split("T")[0].split("-");
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return `${d} ${months[parseInt(m) - 1]} ${y}`;
  };

  const filteredLogs = logs.filter((log) => {
    const text = search.trim().toLowerCase();
    if (!text) return true;

    const first = (log.first_name || "").toLowerCase();
    const code = (log.employee_code || "").toLowerCase();

    return first.startsWith(text) || code.includes(text);
  });

  return (
    <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
      <div className="row">
        <div className="col-12">
          <div className="live-logs-card">
            <div className="d-flex align-items-center gap-2">
              <Activity size={30} stroke="#302867" />
              <div>
                <h5 className="fs-4 fw-semibold m-0">Live Attendance Logs</h5>
                <span className="text-muted fs-6">Attendance punch logs</span>
              </div>
            </div>

            <div className="mt-4 d-flex gap-4 align-items-end">
              <div>
                <label className="form-label fw-semibold">Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={date}
                  max={new Date().toISOString().split("T")[0]}
                  onChange={(e) => setDate(e.target.value)}
                />
              </div>

              <div>
                <label className="form-label fw-semibold">Search</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by name or code..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div>

            {loading ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "250px" }}
              >
                <div className="spinner-border text-primary"></div>
              </div>
            ) : (
              <>
                <div className="table-responsive mt-3">
                  <table className="table table-hover align-middle">
                    <thead>
                      <tr className="text-muted small">
                        <th>Employee Code</th>
                        <th>Name</th>
                        <th>Department</th>
                        <th>Outlet</th>
                        <th>Punch Time</th>
                        <th>Date</th>
                      </tr>
                    </thead>

                    <tbody>
                      {filteredLogs.length > 0 ? (
                        filteredLogs.map((log,i) => (
                          <tr key={log.i}>
                            <td>{log.employee_code}</td>
                            <td>
                              {log.first_name || log.last_name
                                ? `${log.first_name ?? ""} ${
                                    log.last_name ?? ""
                                  }`.trim()
                                : "N/A"}
                            </td>
                            <td>{log.department || "N/A"}</td>
                            <td>{log.outlet || "N/A"}</td>
                            <td>{formatTime(log.punch_at)}</td>
                            <td>{formatDate(log.punch_at)}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6" className="text-center py-3">
                            No Records Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LiveLogs;
